const checklist = {
  CHECKLIST: 'CHECKLIST',
  CHECKLISTS: 'CHECKLISTS',
};
export { checklist };
